/* receipt/types */

import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
    For: t.string,
  }),
  t.partial({
    Items: t.array(t.any),
    CardType: t.array(t.string),
    Type: t.string,
    HTML: t.string,
    Default: t.boolean,
  }),
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const ReceiptCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "ReceiptCodec"
);

export type Receipt = t.TypeOf<typeof ReceiptCodec>;

export enum ReceiptActionTypes {
  FETCH = "@@receipt/FETCH",
  FETCH_SUCCESS = "@@receipt/FETCH_SUCCESS",
  FETCH_ERROR = "@@receipt/FETCH_ERROR",
  SAVE_REQUEST = "@@receipt/SAVE_REQUEST",
  SAVE_SUCCESS = "@@receipt/SAVE_SUCCESS",
  SAVE_ERROR = "@@receipt/SAVE_ERROR",
  DELETE_REQUEST = "@@receipt/DELETE_REQUEST",
  DELETE_SUCCESS = "@@receipt/DELETE_SUCCESS",
  DELETE_ERROR = "@@receipt/DELETE_ERROR",
}

export interface ReceiptState {
  readonly loading: boolean;
  readonly data: Receipt | undefined;
  readonly errors?: string;
}
